import { render, staticRenderFns } from "./Compression_Why.vue?vue&type=template&id=77d570dc&scoped=true"
import script from "./Compression_Why.vue?vue&type=script&lang=js"
export * from "./Compression_Why.vue?vue&type=script&lang=js"
import style0 from "./Compression_Why.vue?vue&type=style&index=0&id=77d570dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77d570dc",
  null
  
)

export default component.exports